import { Component } from '@angular/core';
import {Inject} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {NgIf} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ChangeDetectionStrategy} from '@angular/core';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { HostListener } from '@angular/core';



@Component({
  selector: 'app-work-groups',
  templateUrl: './work-groups.component.html',
  styleUrls: ['./work-groups.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,



})
export class WorkGroupsComponent {

  // @HostListener("scroll", ['$event'])
  // doSomethingOnInternalScroll($event:Event){
  //   let scrollOffset = $event.srcElement.scrollTop;
  //   console.log("scroll: ", scrollOffset);
  // }
  items = Array.from({length: 10}).map((_, i) => `Item #${i}`);
searchTerm: any;

  constructor(
    public dialogRef: MatDialogRef<WorkGroupsComponent>,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }



}

